"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingTypeSelectInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var policy_1 = require("../../types/policy");
var billingTypeOptions = Object.keys(policy_1.BillingTypeLabels).map(function (key, index, arr) { return ({
    value: key,
    label: policy_1.BillingTypeLabels[key],
}); });
function BillingTypeSelectInput(props) {
    var value = props.value, onChange = props.onChange;
    return (react_1.default.createElement(core_ui_1.SelectInput, { value: value, onChange: function (newValue) { return onChange(newValue); }, showSelectAnOption: true, options: billingTypeOptions }));
}
exports.BillingTypeSelectInput = BillingTypeSelectInput;
